import { DocumentCenterPage } from '../pages/document-center-page';
import { ROUTES } from '../constants/routes';

export const routeConfig = {
    path: ROUTES.DASHBOARD,
    component: DocumentCenterPage
};
